import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Cyber Soft Solution"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { com.cybersoftsolution.cybersoftsolutionweb.pages.HomePage() }
        ctx.router.register("/admin/") {
                com.cybersoftsolution.cybersoftsolutionweb.pages.admin.index() }
        ctx.router.register("/admin/create") {
                com.cybersoftsolution.cybersoftsolutionweb.pages.admin.create() }
        ctx.router.register("/admin/home") {
                com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Home() }
        ctx.router.register("/admin/login") {
                com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Login() }
        ctx.router.register("/admin/posts") {
                com.cybersoftsolution.cybersoftsolutionweb.pages.admin.posts() }
        ctx.router.register("/cap") { com.cybersoftsolution.cybersoftsolutionweb.pages.Cap() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("create",
                com.cybersoftsolution.cybersoftsolutionweb.styles.CreateStyle)
        ctx.theme.registerStyle("forget-password-button",
                com.cybersoftsolution.cybersoftsolutionweb.styles.ForgetPasswordButtonStyle)
        ctx.theme.registerStyle("google-button",
                com.cybersoftsolution.cybersoftsolutionweb.styles.GoogleButtonStyle)
        ctx.theme.registerStyle("header-section-linear-gradient-style-desktop",
                com.cybersoftsolution.cybersoftsolutionweb.styles.HeaderSectionLinearGradientStyleDesktop)
        ctx.theme.registerStyle("header-section-linear-gradient-style-mobile",
                com.cybersoftsolution.cybersoftsolutionweb.styles.HeaderSectionLinearGradientStyleMobile)
        ctx.theme.registerStyle("footer-section-radial-gradient",
                com.cybersoftsolution.cybersoftsolutionweb.styles.FooterSectionRadialGradientStyle)
        ctx.theme.registerStyle("banner-section-radial-gradient",
                com.cybersoftsolution.cybersoftsolutionweb.styles.BannerSectionRadialGradientStyle)
        ctx.theme.registerStyle("footer-section-linear-gradient",
                com.cybersoftsolution.cybersoftsolutionweb.styles.FooterSectionLinearGradientStyle)
        ctx.theme.registerStyle("half-black-button",
                com.cybersoftsolution.cybersoftsolutionweb.styles.HalfBlackButtonStyle)
        ctx.theme.registerStyle("login-button",
                com.cybersoftsolution.cybersoftsolutionweb.styles.LoginButtonStyle)
        ctx.theme.registerStyle("login",
                com.cybersoftsolution.cybersoftsolutionweb.styles.LoginStyle)
        ctx.theme.registerStyle("logout-button",
                com.cybersoftsolution.cybersoftsolutionweb.styles.LogoutButtonStyle)
        ctx.theme.registerStyle("my-check-box",
                com.cybersoftsolution.cybersoftsolutionweb.styles.MyCheckBoxStyle)
        ctx.theme.registerStyle("my-menu-icon",
                com.cybersoftsolution.cybersoftsolutionweb.styles.MyMenuIconStyle)
        ctx.theme.registerStyle("navigation-item-style-css",
                com.cybersoftsolution.cybersoftsolutionweb.styles.NavigationItemStyleCss)
        ctx.theme.registerStyle("primary-button",
                com.cybersoftsolution.cybersoftsolutionweb.styles.PrimaryButtonStyle)
        ctx.theme.registerStyle("primary-button-style-disabled",
                com.cybersoftsolution.cybersoftsolutionweb.styles.PrimaryButtonStyleDisabled)
        ctx.theme.registerStyle("register-button",
                com.cybersoftsolution.cybersoftsolutionweb.styles.RegisterButtonStyle)
        ctx.theme.registerStyle("scale_-selected_-item",
                com.cybersoftsolution.cybersoftsolutionweb.styles.Scale_Selected_ItemStyle)
        ctx.theme.registerStyle("scale_-rotate_-selected_-item",
                com.cybersoftsolution.cybersoftsolutionweb.styles.Scale_Rotate_Selected_ItemStyle)
        ctx.theme.registerStyle("selected_-item",
                com.cybersoftsolution.cybersoftsolutionweb.styles.Selected_ItemStyle)
        ctx.theme.registerStyle("search-bar-collapsable",
                com.cybersoftsolution.cybersoftsolutionweb.styles.SearchBarCollapsableStyle)
        ctx.theme.registerStyle("placeholder-color",
                com.cybersoftsolution.cybersoftsolutionweb.styles.placeholderColor)
        ctx.theme.registerStyle("search-text-no-style2",
                com.cybersoftsolution.cybersoftsolutionweb.styles.SearchTextNoStyle2)
        ctx.theme.registerStyle("x-icon-style2",
                com.cybersoftsolution.cybersoftsolutionweb.styles.XIconStyle2)
        ctx.theme.registerStyle("search-bar",
                com.cybersoftsolution.cybersoftsolutionweb.styles.SearchBarStyle)
        ctx.theme.registerStyle("search-text-no",
                com.cybersoftsolution.cybersoftsolutionweb.styles.SearchTextNoStyle)
        ctx.theme.registerStyle("x-icon",
                com.cybersoftsolution.cybersoftsolutionweb.styles.XIconStyle)
        ctx.theme.registerStyle("secondary-button",
                com.cybersoftsolution.cybersoftsolutionweb.styles.SecondaryButtonStyle)
        ctx.theme.registerStyle("secondary-button-style-disabled",
                com.cybersoftsolution.cybersoftsolutionweb.styles.SecondaryButtonStyleDisabled)
        ctx.theme.registerStyle("simple-with-animation",
                com.cybersoftsolution.cybersoftsolutionweb.styles.SimpleWithAnimationStyle)
        ctx.theme.registerStyle("subscribe-bar-collapsable",
                com.cybersoftsolution.cybersoftsolutionweb.styles.SubscribeBarCollapsableStyle)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "root") {
        com.cybersoftsolution.cybersoftsolutionweb.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
